import api from './api'

export default {
  searchUsers(query) {
    return api.get('/enercare/api/v1/auth/impersonate/users/', { params: { search: query } })
  },
  startImpersonation(userId) {
    return api.post('/enercare/api/v1/auth/impersonate/start/', { user_id: userId })
  },
  stopImpersonation() {
    return api.post('/enercare/api/v1/auth/impersonate/stop/')
  }
}
